<template>
  <!-- 页面加载页面 -->
  <div class="svg_div">
    <svg
      id="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-20 0 100.75 133.8"
    >
      <defs>
        <filter id="black-glow" x="0" y="0" width="200%" height="200%">
          <feOffset result="offOut" in="SourceGraphic" dx=".2" dy=".2" />
          <feGaussianBlur result="blurOut" in="offOut" stdDeviation=".5" />
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
      </defs>
      <title>资源 1</title>
      <g id="图层_2" data-name="图层 2">
        <g id="图层_1-2" data-name="图层 1 ">
          <g class="cls-top1">
            <rect class="cls-1" y="28.22" width="7.95" height="3.28" />
            <rect class="cls-1" x="10.35" width="3.28" height="25.79" />
            <path
              class="cls-1"
              d="M8,31.48a5.69,5.69,0,0,0,5.68-5.69H10.35A2.41,2.41,0,0,1,8,28.2Z"
            />

            <g class="cls-down-right">
              <rect
                class="cls-1"
                x="51.47"
                y="65.88"
                width="3.28"
                height="43.37"
              />
              <polygon
                class="cls-1"
                points="41.66 57.77 41.65 47.69 38.38 47.69 38.38 57.77 41.66 57.77"
              />
              <path
                class="cls-1"
                d="M51.47,109.25a2.39,2.39,0,0,1-2.39,2.4v3.28a5.67,5.67,0,0,0,5.67-5.68Z"
              />
              <path
                class="cls-1"
                d="M45.1,45.53a1.07,1.07,0,1,0-1.88-1h0a.83.83,0,0,0,0-.22,1.07,1.07,0,0,0-1.07-1.07,1.06,1.06,0,0,0-1,.94h0v0a1.07,1.07,0,1,0-2.13,0v0h0a1.06,1.06,0,0,0-2.12.13,1.64,1.64,0,0,0,0,.22h0a1.07,1.07,0,1,0-1.89,1,1,1,0,0,0-.26.61c0,1.1,2.39,2,5.34,2s5.33-.89,5.33-2A.9.9,0,0,0,45.1,45.53Z"
              />
              <rect
                class="cls-1"
                x="44.06"
                y="60.2"
                width="5.01"
                height="3.28"
              />
              <path
                class="cls-1"
                d="M44.06,60.17a2.39,2.39,0,0,1-2.4-2.4H38.38a5.68,5.68,0,0,0,5.68,5.68Z"
              />
              <path
                class="cls-1"
                d="M49.08,63.48a2.4,2.4,0,0,1,2.39,2.4h3.28a5.67,5.67,0,0,0-5.67-5.68Z"
              />
              <path
                class="cls-1"
                d="M38.38,51.73s-3.31-.45-4.68-2.84-3.23-.37-1.65,1.28c2.38,2.51,6.33,2.32,6.33,2.32Z"
              />
              <path
                class="cls-1"
                d="M38.38,54.89s-5.24-.32-7.4-2-5.11-.27-2.61.91c3.77,1.79,10,1.65,10,1.65Z"
              />
              <path
                class="cls-1"
                d="M41.65,51.73s3.33-.45,4.69-2.84,3.24-.37,1.66,1.28c-2.39,2.51-6.35,2.32-6.35,2.32Z"
              />
              <path
                class="cls-1"
                d="M41.66,54.89s5.25-.32,7.4-2,5.12-.27,2.62.91c-3.78,1.79-10,1.65-10,1.65Z"
              />
            </g>
          </g>
          <g class="cls-top2">
            <rect class="cls-1" x="38.38" width="3.28" height="31.48" />
            <g class="cls-down-left">
              <rect
                class="cls-1"
                x="10.35"
                y="77.21"
                width="3.28"
                height="26.68"
              />
              <rect class="cls-1" y="60.17" width="3.28" height="54.75" />
              <path
                class="cls-1"
                d="M8,71.53A5.68,5.68,0,1,0,8,60.17v3.28a2.4,2.4,0,1,1,0,4.8Z"
              />
              <rect
                class="cls-1"
                x="3.28"
                y="60.17"
                width="4.67"
                height="3.28"
              />
              <path
                class="cls-1"
                d="M8,74.81a2.41,2.41,0,0,1,2.4,2.4h3.28A5.69,5.69,0,0,0,8,71.53Z"
              />
              <path
                class="cls-1"
                d="M8,109.58a5.69,5.69,0,0,0,5.68-5.69H10.35A2.41,2.41,0,0,1,8,106.3"
              />
            </g>
          </g>
          <g class="cls-top3">
            <rect
              class="cls-1"
              x="5.68"
              y="35.29"
              width="43.42"
              height="3.28"
            />
            <rect class="cls-1" y="40.98" width="3.28" height="4.86" />
            <path
              class="cls-1"
              d="M5.68,35.29A5.68,5.68,0,0,0,0,41H3.28a2.4,2.4,0,0,1,2.4-2.41Z"
            />
            <rect
              class="cls-1"
              x="51.47"
              y="40.98"
              width="3.28"
              height="4.86"
            />
            <path
              class="cls-1"
              d="M49.08,38.57A2.4,2.4,0,0,1,51.47,41h3.28a5.68,5.68,0,0,0-5.67-5.69Z"
            />
            <rect
              class="cls-1"
              x="28.76"
              y="96.21"
              width="3.28"
              height="13.04"
            />
            <path
              class="cls-1"
              d="M34.44,111.65a2.4,2.4,0,0,1-2.4-2.4H28.76a5.68,5.68,0,0,0,5.68,5.68Z"
            />
            <rect
              class="cls-1"
              x="34.44"
              y="111.65"
              width="9.85"
              height="3.28"
            />
          </g>
          <g class="cls-top4">
            <rect class="cls-1" y="51.47" width="14.3" height="3.28" />
            <rect class="cls-1" x="16.7" y="43.46" width="3.28" height="5.59" />
            <path
              class="cls-1"
              d="M14.3,54.72A5.67,5.67,0,0,0,20,49.05H16.7a2.39,2.39,0,0,1-2.4,2.39Z"
            />
            <path
              class="cls-1"
              d="M32,65.85a5.68,5.68,0,0,0-11.36,0H24a2.4,2.4,0,0,1,4.8,0Z"
            />
            <rect
              class="cls-1"
              x="20.68"
              y="65.85"
              width="3.28"
              height="5.68"
            />
            <rect
              class="cls-1"
              x="28.76"
              y="65.85"
              width="3.28"
              height="5.68"
            />
          </g>
          <g class="cls-top5">
            <rect
              class="cls-1"
              x="41.01"
              y="96.13"
              width="3.28"
              height="10.54"
            />
            <rect
              class="cls-1"
              x="20.68"
              y="96.21"
              width="3.28"
              height="13.04"
            />
            <path
              class="cls-1"
              d="M18.28,114.93A5.68,5.68,0,0,0,24,109.25H20.68a2.4,2.4,0,0,1-2.4,2.4Z"
            />
          </g>
          <g class="cls-top6">
            <rect class="cls-1" y="4.84" width="49.08" height="3.28" />
            <rect class="cls-1" x="5.68" y="12.93" width="43.4" height="3.28" />
            <rect class="cls-1" x="5.68" y="21.01" width="43.4" height="3.28" />
            <path
              class="cls-1"
              d="M49.08,32.36a5.68,5.68,0,0,0,0-11.35v3.27a2.4,2.4,0,0,1,0,4.8Z"
            />

            <path
              class="cls-1"
              d="M5.68,12.93a5.68,5.68,0,1,0,0,11.35V21a2.4,2.4,0,1,1,0-4.8Z"
            />
            <path
              class="cls-1"
              d="M49.08,16.21a5.69,5.69,0,0,0,0-11.37V8.12a2.41,2.41,0,0,1,0,4.81Z"
            />
            <path
              class="cls-1"
              d="M40,82.89a5.68,5.68,0,1,0,0-11.36v3.28a2.4,2.4,0,0,1,0,4.8Z"
            />

            <path
              class="cls-1"
              d="M40,91a5.68,5.68,0,1,0,0-11.36v3.28a2.4,2.4,0,0,1,0,4.8Z"
            />
            <rect
              class="cls-1"
              x="20.68"
              y="71.53"
              width="19.35"
              height="3.28"
            />
            <rect
              class="cls-1"
              x="20.68"
              y="79.61"
              width="19.35"
              height="3.28"
            />
            <rect
              class="cls-1"
              x="20.68"
              y="87.69"
              width="19.35"
              height="3.28"
            />
          </g>

          <path
            class="cls-1"
            d="M1,133.8H.28v-7.47H4.59V127H1v2.58H4.34v.68H1Z"
          />
          <path
            class="cls-1"
            d="M11.94,133.13h3.83v.67H11.21v-7.47h4.43V127h-3.7v2.56H15.4v.68H11.94Z"
          />
          <path class="cls-1" d="M23.16,133.8h-.72v-7.47h.72Z" />
          <path
            class="cls-1"
            d="M32.57,133.8h-.73v-3.22l-2.67-4.25h.9L32.23,130l2.17-3.62h.84l-2.67,4.25Z"
          />
          <path class="cls-1" d="M41.77,133.8H41v-7.47h.73Z" />
          <path
            class="cls-1"
            d="M54,132.7h0v-6.37h.73v7.47h-.91l-4.17-6.43h0v6.43h-.73v-7.47h.91Z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  methods: {
    loading() {
      let timer,
        i = 0;
      let cls_arr = [
        "cls-top1",
        "cls-top2",
        "cls-top3",
        "cls-top4",
        "cls-top5",
        "cls-top6"
      ];

      timer = setInterval(() => {
        let el = document.querySelectorAll(`.${cls_arr[i]} .cls-1`);
        let el5 = document.querySelectorAll(`.${cls_arr[5]} .cls-1`);
        let el1 = document.querySelectorAll(`.${cls_arr[1]} .cls-1`);
        el.forEach(element => {
          element.style.animation = "twinkling 2s";
          element.style.fill = "white";
          element.style.display = "block";
          setTimeout(() => {
            el5.forEach(item => {
              item.style.fill = "white";
              item.style.display = "block";
              item.style.animation = "twinkling 6.3s";
            });
          }, 500);
          setTimeout(() => {
            el1.forEach(item => {
              item.style.fill = "white";
              item.style.display = "block";
              item.style.animation = "twinkling 4s";
            });
          }, 200);
        });

        i++;
        if (i > 5) {
          clearInterval(timer);
          let cl = document.querySelectorAll(".svg_div #图层_1-2 >.cls-1");
          cl.forEach(element => {
            element.style.fill = "white";
            element.style.display = "block";
          });
        }
      }, 600);
    }
  },
  mounted() {
    this.loading();
  }
};
</script>

<style>
.svg_div {
  background: #161f28;
  position: absolute;
  text-align: center;
  top: 0;
  line-height: 100vh;
  width: 80vw;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  min-width: 1080px;
}
#svg {
  height: 15%;
  width: 10%;
  -webkit-filter: drop-shadow(0px 0px 10px white);
  filter: drop-shadow(0px 0px 10px white);
}

.svg_div .cls-1 {
  display: none;
}
@-webkit-keyframes twinkling {
  0%,
  15%,
  50% {
    opacity: 1;
    box-shadow: 0 0 60px #fff;
  }
  10%,
  25% {
    opacity: 0;
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.5);
  }
}
@keyframes twinkling {
  0%,
  15%,
  50% {
    opacity: 1;
    box-shadow: 0 0 60px #fff;
  }
  10%,
  25% {
    opacity: 0;
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.5);
  }
}
</style>
